var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame2608418({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 6.22168L18.6666 12.2217L9.33325 18.2217V6.22168Z",
    fill: "#2B3340"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.72168,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#DEDAF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2608418);
export default __webpack_public_path__ + "static/media/Frame 2608418.6e2977b02ada8325ca60ab1bba3204d7.svg";
export { ForwardRef as ReactComponent };